import React, { useEffect, useState } from 'react'
import  Select  from 'react-select';
import { estados } from './dataCities';

const initOptions = [ { value: "chocolate", label: "Chocolate" },
{ value: "strawberry", label: "Strawberry" },
{ value: "vanilla", label: "Vanilla" },
];
const initValue = { value: "elegir", label: "elegir" };
const SelectEstado = ({setEstadoSelected, handleChangeEstado}) => {
    const[dataOptions,setDataOptions]=useState(initOptions);
    const[valueSelect,setValueSelect]=useState(initValue);
    useEffect(() => {
        formatDataOptions()
    }, [])
    const formatDataOptions = () => {
        const data = estados.map((item,index) => {
            return { value: item, label: item, index }
        })
        setDataOptions(data)
    }
    const handleChange = ({value,label,index}) => {

        //console.log(estado)
        setValueSelect({value,label});
        setEstadoSelected(index);
        handleChangeEstado(value);
    }
  return (
    <div>
        <Select
        value={valueSelect}
        className="w-100 me-auto ms-auto my-2"
        options={dataOptions}
        placeholder="Buscar..."
        onChange={handleChange}
        />
    </div>
  )
}

export default SelectEstado